import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-user-lock-icon]',
  template: `
    <svg:path
      d="M17.5 13.5C19.1569 13.5 20.5 14.8431 20.5 16.5V17.0635C21.3626 17.2855 22 18.0681 22 19V21C22 22.1046 21.1046 23 20 23H15C13.8954 23 13 22.1046 13 21V19C13 18.0681 13.6374 17.2855 14.5 17.0635V16.5C14.5 14.8431 15.8431 13.5 17.5 13.5ZM11 15C11.5523 15 12 15.4477 12 16C12 16.5523 11.5523 17 11 17H6C4.89543 17 4 17.8954 4 19V21C4 21.5523 3.55228 22 3 22C2.44772 22 2 21.5523 2 21V19C2 16.7909 3.79086 15 6 15H11ZM15 21H20V19H15V21ZM17.5 15.5C16.9477 15.5 16.5 15.9477 16.5 16.5V17H18.5V16.5C18.5 15.9477 18.0523 15.5 17.5 15.5ZM11 2C14.0376 2 16.5 4.46243 16.5 7.5C16.5 10.5376 14.0376 13 11 13C7.96243 13 5.5 10.5376 5.5 7.5C5.5 4.46243 7.96243 2 11 2ZM11 4C9.067 4 7.5 5.567 7.5 7.5C7.5 9.433 9.067 11 11 11C12.933 11 14.5 9.433 14.5 7.5C14.5 5.567 12.933 4 11 4Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserLockIcon {
  readonly viewBox = input<string>('0 0 24 24');
}
